import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

const Signin = () => {
  const BaseUrl = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [formdata, setFormdata] = useState({
    email: "",
    password: "",
  });
  
  const [failedAttempts, setFailedAttempts] = useState(0);
  const [lockoutEndTime, setLockoutEndTime] = useState(null);

  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [resendTimer, setResendTimer] = useState(30);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  const navigate = useNavigate();



  useEffect(() => {
    const jwtToken = localStorage.getItem("authToken");

    if (jwtToken) {
      axios
        .post(`${BaseUrl}/validate-token`, { token: jwtToken })
        .then((response) => {
          if (response.data.valid) {
            navigate("/");
          }
        })
        .catch((error) => {
          console.error("Error validating token:", error);
        });
    }
  }, [navigate]);

  const [sessionsformData, setSessionsFormData] = useState({
    status: "",
    platform: "",
    deviceName: "",
    locationIp: "",
  });

  useEffect(() => {
    createAndSendUserSessionData();
    // eslint-disable-next-line
  }, []);

  const formatDeviceName = () => {
    const userAgent = navigator.userAgent;
    const matches = userAgent.match(/\(([^)]+)\)/);
    return matches ? matches[1] : "Unknown";
  };

  const getIPAddress = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      if (!response.ok) {
        throw new Error("Failed to fetch IP address");
      }
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error("Error fetching IP address:", error);
      return null;
    }
  };

  const isAppEnvironment = () => {
    return typeof window.MyAppBridge !== "undefined";
  };

  const createAndSendUserSessionData = async () => {
    const status = "active";
    const platform = isAppEnvironment() ? "app" : "web";
    const deviceName = formatDeviceName();
    const locationIp = await getIPAddress();

    setSessionsFormData({
      status,
      platform,
      deviceName,
      locationIp,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormdata({
      ...formdata,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
     // Check if the user is locked out
     if (lockoutEndTime && new Date() < new Date(lockoutEndTime)) {
      const remainingTime = Math.ceil((new Date(lockoutEndTime) - new Date()) / 1000);
      NotificationManager.error(`Too many failed attempts. Try again in ${remainingTime} seconds.`);
      return;
    }

    setLoading(true);
    if (formValid) {
    try {
      const combinedData = { ...formdata, ...sessionsformData };
      const response = await axios.post(`${BaseUrl}/signinNavAdmin`, combinedData);
  
      setLoading(false);
  
      if (response.data.success) {
        setOtpSent(true); // OTP is sent
        NotificationManager.info("OTP Sent Successfully");
      } else {
        const { errors } = response.data;
  
            // Increment failed attempts
        const newFailedAttempts = failedAttempts + 1;
        setFailedAttempts(newFailedAttempts);

        if (newFailedAttempts >= 3) {
          // Lock out the user for 5 minutes
          const lockoutUntil = new Date();
          lockoutUntil.setMinutes(lockoutUntil.getMinutes() + 1);
          setLockoutEndTime(lockoutUntil);
          NotificationManager.error("Too many failed attempts. Please try again in 1 minutes.");
        } else {
          NotificationManager.error("Invalid email or password. Please try again.");
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      setLoading(false);
      NotificationManager.error("An error occurred while processing your request. Please try again later.");
    }
  }
  };
  

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // Check if the user is locked out
  //   if (lockoutEndTime && new Date() < new Date(lockoutEndTime)) {
  //     const remainingTime = Math.ceil((new Date(lockoutEndTime) - new Date()) / 1000);
  //     NotificationManager.error(`Too many failed attempts. Try again in ${remainingTime} seconds.`);
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const response = await axios.post(`${BaseUrl}/signinNavAdmin`, formdata);
  //     setLoading(false);

  //     if (response.data.success) {
  //       // Reset failed attempts on successful login
  //       setFailedAttempts(0);
  //       setLockoutEndTime(null);

  //       const { token } = response.data;
  //       localStorage.setItem("authToken", token);
  //       navigate("/");
  //       NotificationManager.success("Login Successful.");
  //     } else {
  //       // Increment failed attempts
  //       const newFailedAttempts = failedAttempts + 1;
  //       setFailedAttempts(newFailedAttempts);

  //       if (newFailedAttempts >= 3) {
  //         // Lock out the user for 5 minutes
  //         const lockoutUntil = new Date();
  //         lockoutUntil.setMinutes(lockoutUntil.getMinutes() + 1);
  //         setLockoutEndTime(lockoutUntil);

  //         NotificationManager.error("Too many failed attempts. Please try again in 5 minutes.");
  //       } else {
  //         NotificationManager.error("Invalid email or password. Please try again.");
  //       }
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error in handleSubmit:", error);
  //     NotificationManager.error("An error occurred. Please try again later.");
  //   }
  // };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setIsVerifyingOtp(true);
  
    try {
      const res = await axios.post(`${BaseUrl}/verifyOtpNavAdmin`, { email: formdata.email, otp,...sessionsformData });
      setIsVerifyingOtp(false);
  
      if (res.data.success) {
        const { token } = res.data;
        window.localStorage.setItem("authToken", token);
        navigate("/");
        NotificationManager.success("Login Successful.");
      } else {
        NotificationManager.error("Invalid OTP. Please try again.");
      }
    } catch (err) {
      setIsVerifyingOtp(false);
      console.error("Error in handleVerifyOtp:", err);
      NotificationManager.error("An error occurred. Please try again.");
    }
  };
  
  const handleResendOtp = async () => {
    if (resendTimer > 0) return;
  
    try {
      await axios.post(`${BaseUrl}/resendOtpNavAdmin`, { email: formdata.email });
      setResendTimer(30); // Reset timer
      NotificationManager.info("OTP Sent Successfully");
    } catch (err) {
      console.error("Error in handleResendOtp:", err);
      NotificationManager.error("Failed to resend OTP.");
    }
  };
  
  // Start a countdown when OTP is sent
  useEffect(() => {
    if (otpSent && resendTimer > 0) {
      const timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
  
      return () => clearInterval(timer);
    }
  }, [otpSent, resendTimer]);
  
  React.useEffect(() => {
    const { email, password } = formdata;
    const isValid = email.trim() !== "" && password.trim() !== "";
    setFormValid(isValid);
  }, [formdata]);

    // Prevent right-click menu
    const handleContextMenu = (e) => {
      e.preventDefault();
    };
    
  return (
    <>
      <div onContextMenu={handleContextMenu}  className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div id="message"></div>
            <div id="completeform">
             <form id="mform" onSubmit={otpSent ? handleVerifyOtp : handleSubmit}>
              <div className="row justify-content-center">
                <div className="col-lg-5">
                  <div className="card">
                    <div className="card-header">
                      <h4
                        className="card-title fw-bold d-flex justify-content-center"
                        style={{ color: "#776ad8", fontSize: "25px" }}
                      >
                        Welcome to Blue Aster!
                      </h4>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-xl-12">
                          {!otpSent && (
                            <>
                              <div className="mb-3 row">
                                <label htmlFor="email" className="col-md-12 mb-2">
                                  Email Address
                                </label>
                                <div className="col-md-12">
                                  <input
                                    className="form-control"
                                    type="email"
                                    id="email"
                                    name="email"
                                    onChange={handleChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label htmlFor="password" className="col-md-12 mb-2">
                                  Password
                                </label>
                                <div className="col-md-12">
                                  <input
                                    className="form-control"
                                    type="password"
                                    id="password"
                                    name="password"
                                    onChange={handleChange}
                                    required
                                  />
                                </div>
                              </div>
                              {/* <div className="mb-3 row">
                              <div className="col-md-12">
                                <Link
                                  to="/forgot-password"
                                  className="forgot-password-link"
                                >
                                  Forgot Password?
                                </Link>
                              </div>
                            </div> */}
                            </>
                          )}
                          
                          {otpSent && (
                            <>
                              <div className="mb-3 row">
                                <label htmlFor="otp" className="col-md-12 mb-2">
                                  Enter OTP
                                </label>
                                <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="otp"
                                  name="otp"
                                  value={otp}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    // Allow only numbers and limit to 6 digits
                                    if (/^\d{0,6}$/.test(value)) {
                                      setOtp(value);
                                    }
                                  }}
                                  required
                                />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <button
                                  type="button"
                                  className="btn "
                                  onClick={handleResendOtp}
                                  disabled={resendTimer > 0}
                                >
                                  Resend OTP {resendTimer > 0 && `in ${resendTimer}s`}
                                </button>
                              </div>
                            </>
                          )}

                          <div className="mb-3 row">
                            <div className="col-md-12">
                              <input
                                type="submit"
                                className="btn btn-primary btn-lg fw-bold w-100"
                                value={otpSent ? "Verify OTP" : "Login"}
                                disabled={!formValid || loading}
                              />                                
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signin;
